var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogojabil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.271,
    height: 12.157,
    viewBox: "0 0 74.271 12.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27789",
    "data-name": "Grupo 27789",
    transform: "translate(0 -2.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27741",
    "data-name": "Grupo 27741",
    transform: "translate(0 2.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27740",
    "data-name": "Grupo 27740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38223",
    "data-name": "Caminho 38223",
    d: "M94.527,30.6V25.052H94.8c3.336,0,6.671-.005,10.006.006a6.494,6.494,0,0,1,1.335.146,1.719,1.719,0,0,1,1.443,1.623,16.458,16.458,0,0,1,.036,2.263,1.79,1.79,0,0,1-1.385,1.684c-.167.055-.339.094-.473.131a8.536,8.536,0,0,1,1.018.451,1.9,1.9,0,0,1,.936,1.6,17.908,17.908,0,0,1,0,2.154,1.961,1.961,0,0,1-1.457,1.777,6.732,6.732,0,0,1-2.282.306c-3.08.01-6.161,0-9.241,0-.066,0-.132-.006-.221-.011v-.253c0-1.916,0-3.832,0-5.748M97.3,35c.077,0,.135.011.193.011q3.158,0,6.318,0a3.153,3.153,0,0,0,.536-.05.788.788,0,0,0,.736-.821c.014-.456.014-.913,0-1.369a.742.742,0,0,0-.663-.782,3.554,3.554,0,0,0-.713-.073q-3.08-.008-6.16,0c-.079,0-.159.007-.246.011Zm0-5.091c.088,0,.169.012.249.012,2.045,0,4.09,0,6.135,0a3.853,3.853,0,0,0,.779-.083A.615.615,0,0,0,105,29.2c.016-.486.014-.972,0-1.458a.6.6,0,0,0-.481-.6,2.673,2.673,0,0,0-.64-.089c-2.112-.006-4.225,0-6.338,0H97.3Z",
    transform: "translate(-59.856 -25.048)",
    fill: "#005288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38224",
    "data-name": "Caminho 38224",
    d: "M31.509,34.916V25.089h2.839v.277c0,2.965,0,5.929,0,8.894a7.313,7.313,0,0,1-.1,1.249,1.7,1.7,0,0,1-1.569,1.57,10.107,10.107,0,0,1-1.564.134q-2.373.025-4.745,0a9.082,9.082,0,0,1-1.5-.124,1.755,1.755,0,0,1-1.674-1.821c-.064-.744-.05-1.495-.065-2.242-.007-.344-.007-.689,0-1.033,0-.067.066-.181.117-.191.87-.175,1.743-.337,2.616-.5a.606.606,0,0,1,.1.006v.255c0,1.048,0,2.1,0,3.144,0,.157.029.227.208.226,1.724-.006,3.448,0,5.172,0C31.39,34.929,31.434,34.922,31.509,34.916Z",
    transform: "translate(-23.124 -25.068)",
    fill: "#005288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38225",
    "data-name": "Caminho 38225",
    d: "M151.616,25.087h2.824v9.829h9.08v2.29h-11.9Z",
    transform: "translate(-89.248 -25.067)",
    fill: "#005288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38226",
    "data-name": "Caminho 38226",
    d: "M133,37.2V25.088h2.812V37.2Z",
    transform: "translate(-79.67 -25.067)",
    fill: "#005288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38227",
    "data-name": "Caminho 38227",
    d: "M68.473,36.43q-.94-1.639-1.884-3.276h0c-1-1.749-3.537-6.179-4.538-7.929a.3.3,0,0,0-.3-.179c-.78.009-1.559.007-2.339,0a.277.277,0,0,0-.283.16q-1.312,2.332-2.637,4.657-1.831,3.236-3.661,6.472c-.156.277-.312.554-.484.861.937,0,1.834,0,2.731-.006.055,0,.128-.085.162-.148.346-.645.678-1.3,1.029-1.938q1.928-3.532,3.865-7.059c.109-.2.221-.394.347-.617.048.081.076.123.1.168.364.684,2.015,3.748,3.083,5.742.018.042.03.071.044.1l.809,1.5.009.017h0q.568,1.054,1.142,2.1a.329.329,0,0,0,.242.133c.749.01,1.5.006,2.248.006h.751C68.752,36.918,68.613,36.673,68.473,36.43Z",
    transform: "translate(-38.164 -25.045)",
    fill: "#005288"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38228",
    "data-name": "Caminho 38228",
    d: "M60.289,41.093l17.719-4.6-15.172-.065Z",
    transform: "translate(-42.251 -30.904)",
    fill: "#15bef0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogojabil);
export default __webpack_public_path__ + "static/media/logo jabil.9ba0585e2a1163c5295cdeb461fa3a18.svg";
export { ForwardRef as ReactComponent };